import { LinkButton } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { type MouseEventHandler } from "react";

interface Props {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}
export const ResetSortBtn = ({ className, onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <LinkButton className={className} onClick={onClick} iconBefore={<Icon type={IconType.ArrowsUpDown} />}>
      {t("page.selectionAssistant.resetSort")}
    </LinkButton>
  );
};
